import * as React from 'react';

import {sortNavItems} from '../helpers';
import type {SubmenuNavItem} from '../types';

import {LinkItem} from './link-item';

import styles from './section-submenu.module.css';

type Props = {
    submenu: SubmenuNavItem[];
    footer?: React.ReactNode;
};

export function SectionSubmenu(props: Props) {
    const sortedSubmenu = sortNavItems(props.submenu);

    return (
        <ul className={styles.list}>
            {sortedSubmenu.map((item) => (
                <LinkItem
                    key={typeof item.label === 'string' ? item.label : item.id || ''}
                    id={typeof item.label === 'string' ? item.label : item.id || ''}
                    linkText={item.label}
                    to={item.to}
                    isSubmenuItem={true}
                    activeMatch={item.activeMatch}
                    searchMatch={item.searchMatch}
                    count={item.count}
                    icon={item.icon}
                    requiresUpgrade={item.requiresUpgrade}
                    isExternalLink={item.isExternalLink}
                    warningTooltip={item.warningTooltip}
                />
            ))}
            {props.footer}
        </ul>
    );
}
